// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hlya","label":"styles_label__3mEgB"};